import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        alerts:[],
        deleteStatus:null,
        singlealert:[],
        topalerts:null,
        alertslist:[],
        threat:[],
        compliancestandards:[],
        availablestandards:[],
    };
  };

const alertSlice = createSlice({
  name: 'ecsAlert',
  initialState:initialState(),
  reducers: {
    setAlerts(state, action) {
      state.alerts = action.payload;
    },
    setdeleteStatus(state,status) {
      state.deleteStatus = status;
    },
    
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setSingleAlert(state,action){
      state.singlealert=action.payload;
    },
    setTopAlerts(state,action){
      state.topalerts=action.payload;
    },
    setAlertsList(state, action) {
      state.alertslist= action.payload;
    },
    setThreat(state,action)
    {
      state.threat= action.payload;
    },
    setComplianceStandards(state,action)
    {
      state.compliancestandards= action.payload;
    },
    setAvailableStandards(state,action)
    {
      state.availablestandards= action.payload;
    }
  },
});

export const {
  setAlerts,
  setErrors,
  setdeleteStatus,
  setSingleAlert,
  setTopAlerts,
  setAlertsList,
  setThreat,
  setComplianceStandards,
  setAvailableStandards
} = alertSlice.actions;
export const ecsAlert=alertSlice.reducer;